"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../../theming/make-styles.js";
import Radio from "./radio.js";
const useStyles = makeStyles()((theme, { columnGap, direction, rowGap }) => ({
    group: {
        display: "grid",
        columnGap: theme.spacing(columnGap),
        rowGap: theme.spacing(rowGap),
        gridAutoFlow: direction === "vertical" ? "row" : "column",
    },
}));
export function RadioGroup(_a) {
    var { children, className, customRadio: CustomRadio = Radio, direction = "horizontal", gap = direction === "horizontal" ? "md" : "xs", reverseOrder = false, value, columnGap = gap, rowGap = gap, onChange } = _a, props = __rest(_a, ["children", "className", "customRadio", "direction", "gap", "reverseOrder", "value", "columnGap", "rowGap", "onChange"]);
    const { classes, cx } = useStyles({ columnGap, direction, rowGap });
    return (_jsx("div", Object.assign({ "aria-orientation": direction, className: cx(classes.group, className), "data-component": "radio-group", role: "radiogroup" }, props, { children: React.Children.map(children, (child) => !!child && (_jsx(CustomRadio, Object.assign({ reverseOrder: reverseOrder }, child.props, { value: value === child.props.value, onChange: value => {
                if (value)
                    onChange(child.props.value);
            } })))) })));
}
export default RadioGroup;
//# sourceMappingURL=radio-group.js.map